import MatomoProvider, { matomo } from './MatomoProvider';

export {
  MatomoProvider,
  matomo
};
